import React, { memo, useEffect, useState, useRef } from 'react';

import {ReactComponent as OuterLine } from 'Assets/GraphicSection/container_line.svg';

//SCSS
import classes from './GraphicSection.module.scss'

function GraphicSection({showMe, onGraphicSelectedCallback, graphicKey, graphicData, graphicIndex }){
    const [changeLine, setChangeLine] = useState('none');

    let singleRef = useRef();
   
    //Bring the map to the front of all the other panels
    useEffect(() => {
    },[graphicKey]);

    

    useEffect(() => {
        console.log(showMe)
        if(showMe){
            singleRef.current.classList.add(classes["GraphicSection--active"])
           
        }else{
            singleRef.current.classList.remove(classes["GraphicSection--active"])
        }
    },[showMe])

    function onGraphicSelected(){

        onGraphicSelectedCallback(graphicKey)

    }

    function over(e){
        setChangeLine('#fff')
    }
    function out(e){
        setChangeLine('none')
    }

    return (
        <div ref={singleRef} id={`icon-${graphicIndex}`}className={`icon ${classes.GraphicSection}`} onClick={onGraphicSelected} onMouseOver={over} onMouseOut={out}>
            <div className={classes.GraphicSection__inner}>
                <div className={classes.GraphicSection__outerLine}>  
                    <OuterLine fill={changeLine}  />
                </div>
                <div className={classes.GraphicSection__numberContainer}>
                    <span className={classes.GraphicSection__number}>{graphicIndex}.</span>
                </div> 
                <div className={classes.GraphicSection__icon}>    
                    {graphicData.icon}
                </div>
            </div>
            <p className={classes.GraphicSection__title} dangerouslySetInnerHTML={{__html: graphicData.title}}></p>
        </div>
    )
}

export default memo( GraphicSection )